import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GreetingData, GreetingService } from '../@core/greeting/greeting.service';
import { DeclarationPromptData, DeclarationPromptService } from '../@core/declaration-prompt/declaration-prompt.service';

import { MENU_ITEMS } from './pages-menu';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
    <app-greeting-popup
      [greeting]="currentGreeting"
      (dismissed)="onGreetingDismissed()"
    ></app-greeting-popup>
    <app-declaration-prompt
      [promptData]="currentPrompt"
      (dismissed)="onDeclarationPromptDismissed()"
    ></app-declaration-prompt>
    <app-declaration-draft-notice
      [show]="showDraftNotice"
      (dismissed)="onDraftNoticeDismissed()"
    ></app-declaration-draft-notice>
  `,
})
export class PagesComponent implements OnInit, OnDestroy {
  menu = MENU_ITEMS;
  currentGreeting: GreetingData | null = null;
  currentPrompt: DeclarationPromptData | null = null;
  showDraftNotice = false;
  private greetingSubscription: Subscription;
  private declarationPromptSubscription: Subscription;
  private draftNoticeSubscription: Subscription;

  

  constructor(
    private greetingService: GreetingService,
    private declarationPromptService: DeclarationPromptService
  ) {
    

  }

  ngOnInit(): void {
    void this.declarationPromptService.checkPromptEligibility();

    this.greetingSubscription = this.greetingService.greeting$.subscribe(
      (greeting) => {
        this.currentGreeting = greeting;
      }
    );

    this.declarationPromptSubscription = this.declarationPromptService.prompt$.subscribe(
      (prompt) => {
        this.currentPrompt = prompt;
      }
    );

    this.draftNoticeSubscription = this.declarationPromptService.draftNotice$.subscribe(
      (shouldShow) => {
        this.showDraftNotice = shouldShow;
      }
    );
  }

  onGreetingDismissed(): void {
    this.greetingService.dismissGreeting();
    this.currentGreeting = null;
  }

  onDeclarationPromptDismissed(): void {
    this.declarationPromptService.dismissPrompt();
    this.currentPrompt = null;
  }

  onDraftNoticeDismissed(): void {
    this.declarationPromptService.dismissDraftNotice();
  }

  ngOnDestroy(): void {
    if (this.greetingSubscription) {
      this.greetingSubscription.unsubscribe();
    }
    if (this.declarationPromptSubscription) {
      this.declarationPromptSubscription.unsubscribe();
    }
    if (this.draftNoticeSubscription) {
      this.draftNoticeSubscription.unsubscribe();
    }
  }
}

